@if ({
  title: title$ | async,
  showBack: showBack$ | async
  }; as model) {
  <ng-container>
    <nav class="bg-white" aria-labelledby="Accueil de l'EC">
      <ng-container *ngTemplateOutlet="menuContent"></ng-container>
    </nav>
    <hr class="separator separator--gray4" />
  </ng-container>
  <ng-template #menuContent>
    <div class="site-width">
      <div class="container-fluid">
        <div class="sticky-navbar navbar mx-0">
          <h1 class="pl-0 pb-0 mb-0 mt-0 mb-md-2 no-signature menu-title" data-e2e="e2e-ecm-orange-menu-title">
            <a routerLink="/accueil">{{"ecm.menu.title" | translate}}</a>
          </h1>
        </div>
        <a
          class="h1 menu-subtitle mb-0 pb-1"
          data-e2e="e2e-ecm-orange-menu-subtitle"
          href=""
          (click)="navigateToBackRoute();false"
          >
          <div class="d-flex align-items-center">
            @if (model.showBack) {
              <span class="icon-arrow-previous text-primary pr-1" aria-hidden="true"></span>
            }
            <span>{{model.title}}</span>
          </div>
        </a>
      </div>
    </div>
  </ng-template>
}
